module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0026.jpg?v=d93e7ca8";